import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductElement, SOLAR_COLLECTOR_USAGES } from '../../../../services/backend.service';

@Component({
    selector: 'app-change-usage',
    templateUrl: './change-usage.component.html',
    styleUrls: ['./change-usage.component.scss'],
    standalone: false,
})
export class ChangeUsageComponent {
    data = inject<ProductElement>(MAT_DIALOG_DATA);

    usages = SOLAR_COLLECTOR_USAGES;

    dialogValue?: string;

    constructor() {
        const data = this.data;

        this.dialogValue = data.config.usage;
    }
}
